/* rtf-pdp-subscribe.js
   Powers the One-time / Subscribe & save toggle (snippet: rtf-pdp-subscribe.liquid).
   Reads the CURRENT variant's selling_plan_allocations from the product JSON and,
   when Subscribe is chosen, writes the selected selling_plan id into the product
   form's hidden input so add-to-cart creates the real subscription. Re-syncs on
   size/variant change. Progressive: if anything fails, the plain one-time form works. */
(function () {
  var product = null;
  var mode = 'onetime';

  function money(c) { return '$' + (Number(c) / 100).toFixed(2); }
  function form() { return document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'); }

  function currentVariantId() {
    var f = form();
    var i = f && f.querySelector('[name="id"]');
    if (i && i.value) return i.value;
    return product && product.variants && product.variants[0] && product.variants[0].id;
  }
  function variant() {
    var id = String(currentVariantId());
    var vs = (product && product.variants) || [];
    return vs.filter(function (v) { return String(v.id) === id; })[0] || vs[0];
  }
  function setSellingPlan(id) {
    var f = form(); if (!f) return;
    var inp = f.querySelector('input[name="selling_plan"]');
    if (id) {
      if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'selling_plan'; f.appendChild(inp); }
      inp.value = id;
    } else if (inp) {
      inp.parentNode.removeChild(inp);
    }
  }
  /* rtf-size-required.liquid leaves a disabled placeholder option in the size
     dropdown until a size is chosen. Its presence is the signal that the hidden
     id input still holds Shopify's default first variant rather than a choice —
     so these prices must be a range, not that variant's numbers. */
  function unchosen() {
    return !!document.querySelector('variant-selects option[data-rtf-placeholder]');
  }

  /* Cheapest AVAILABLE variant — the same rule price.liquid uses for a card's
     "From" price, so the toggle cannot quote a different figure than the price
     directly above it. */
  function cheapestVariant() {
    var vs = (product && product.variants) || [];
    var best = null;
    vs.forEach(function (v) {
      if (!v.available) return;
      if (best === null || v.price < best.price) best = v;
    });
    return best || vs[0];
  }

  function mainPriceEl() {
    return document.querySelector('.product__info-wrapper .price .price-item--regular') ||
           document.querySelector('.product__info-wrapper .price .price-item--sale') ||
           document.querySelector('.product__info-wrapper .price .price-item');
  }
  function setMainPrice(cents, restore) {
    var el = mainPriceEl(); if (!el) return;
    if (restore) { if (el.__rtfOrig != null) { el.textContent = el.__rtfOrig; el.__rtfOrig = null; } return; }
    if (el.__rtfOrig == null) el.__rtfOrig = el.textContent;
    el.textContent = money(cents);
  }

  function planMap() {
    var m = {};
    (product.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (sp) {
        m[sp.id] = (sp.options && sp.options[0] && sp.options[0].value) || sp.name || '';
      });
    });
    return m;
  }

  function render() {
    var root = document.querySelector('[data-rtf-sub]');
    if (!root || !product) return;
    var v = variant();
    var allocs = (v && v.selling_plan_allocations) || [];
    // reset the captured original price so it re-captures the current variant's price
    var pe = mainPriceEl(); if (pe) pe.__rtfOrig = null;
    if (!allocs.length) { root.hidden = true; mode = 'onetime'; setSellingPlan(''); return; }

    var pending = unchosen();
    var pv = pending ? cheapestVariant() : v;
    var pAllocs = pending ? ((pv && pv.selling_plan_allocations) || allocs) : allocs;
    var first = pAllocs[0] || allocs[0];
    var pfx = pending ? 'From ' : '';

    root.querySelector('[data-onetime-price]').textContent = pfx + money(pv.price);
    root.querySelector('[data-sub-price]').textContent = pfx + money(first.price);

    var badge = root.querySelector('[data-sub-badge]');
    var base = (first.compare_at_price && first.compare_at_price > first.price) ? first.compare_at_price : pv.price;
    if (base > first.price) {
      badge.textContent = 'Save ' + Math.round((base - first.price) / base * 100) + '%';
      badge.hidden = false;
    } else { badge.hidden = true; }

    var sel = root.querySelector('[data-rtf-cad-select]');
    var prev = sel.value;
    var names = planMap();
    sel.innerHTML = allocs.map(function (a) {
      var label = (names[a.selling_plan_id] || '').replace(/^Deliver(y)? every\s*/i, '').replace(/^every\s*/i, '');
      if (!label) label = 'Recurring';
      return '<option value="' + a.selling_plan_id + '" data-cents="' + a.price + '">' + label + '</option>';
    }).join('');
    if (prev) { sel.value = prev; if (!sel.value) sel.selectedIndex = 0; }

    root.hidden = false;
    applyMode();
  }

  function applyMode() {
    var root = document.querySelector('[data-rtf-sub]'); if (!root) return;
    root.querySelectorAll('.rtf-sub__opt').forEach(function (o) {
      var on = o.getAttribute('data-mode') === mode;
      o.classList.toggle('is-active', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var cad = root.querySelector('[data-rtf-cadence]');
    if (mode === 'subscribe') {
      cad.hidden = false;
      var sel = root.querySelector('[data-rtf-cad-select]');
      var opt = sel.options[sel.selectedIndex] || sel.options[0];
      if (opt) {
        setSellingPlan(sel.value || opt.value);
        /* Leave the headline price alone until a size is chosen: it is showing
           "From $x" and writing one variant's price over it re-creates exactly
           the contradiction this is meant to remove. */
        if (!unchosen()) setMainPrice(parseInt(opt.getAttribute('data-cents'), 10));
      }
    } else {
      cad.hidden = true;
      setSellingPlan('');
      if (!unchosen()) setMainPrice(0, true);
    }
  }

  function wire() {
    var root = document.querySelector('[data-rtf-sub]'); if (!root || root.__wired) return; root.__wired = true;
    root.querySelectorAll('.rtf-sub__opt').forEach(function (o) {
      o.addEventListener('click', function () { mode = o.getAttribute('data-mode'); applyMode(); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); mode = o.getAttribute('data-mode'); applyMode(); }
      });
    });
    root.querySelector('[data-rtf-cad-select]').addEventListener('change', applyMode);
  }

  function init() {
    var root = document.querySelector('[data-rtf-sub]'); if (!root) return;
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        wire();
        render();
        document.addEventListener('variant:change', render);
        document.addEventListener('change', function (e) {
          if (e.target && (e.target.name === 'id' || (e.target.closest && e.target.closest('variant-selects')))) setTimeout(render, 60);
        });
        var f = form();
        var idInp = f && f.querySelector('[name="id"]');
        if (idInp && window.MutationObserver) new MutationObserver(render).observe(idInp, { attributes: true, attributeFilter: ['value'] });
      })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
